/**
 * Lens folder naming — folders may carry a Finder-facing type suffix in
 * brackets (`ohlord-dotted [generate]`). The suffix is purely organizational:
 * the wire slug is always the folder name with the suffix stripped, so
 * renaming a folder to add/change its bracket suffix never changes the slug
 * that grants and render history reference.
 */

import { readdirSync } from "node:fs";
import { join } from "path";

export const LENSES_RELATIVE_DIR = "_appostle-lenses";

/** `"ohlord-dotted [generate]"` → `"ohlord-dotted"`. Names without a suffix pass through. */
export function stripLensTypeSuffix(folderName: string): string {
  return folderName.replace(/\s*\[[^\]]*\]\s*$/, "");
}

/**
 * Resolves a wire slug to its on-disk lens folder, tolerating an optional
 * bracket suffix on the folder name. Falls back to the bare slug path when
 * the lenses dir is unreadable or no folder matches.
 */
export function resolveLensDir(cwd: string, slug: string): string {
  const dir = join(cwd, LENSES_RELATIVE_DIR);
  try {
    for (const entry of readdirSync(dir, { withFileTypes: true })) {
      if (entry.isDirectory() && stripLensTypeSuffix(entry.name) === slug) {
        return join(dir, entry.name);
      }
    }
  } catch {
    // Fall through to the bare-slug path.
  }
  return join(dir, slug);
}
